import { render } from "./DcfGaapsLogo.vue?vue&type=template&id=f82966ce"
import script from "./DcfGaapsLogo.vue?vue&type=script&lang=js"
export * from "./DcfGaapsLogo.vue?vue&type=script&lang=js"

import "./DcfGaapsLogo.vue?vue&type=style&index=0&id=f82966ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__